// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WIo3","type":"styles_type__3wDGk","choices":"styles_choices__a8YmQ"};